// extracted by mini-css-extract-plugin
export var button = "_jt-2";
export var card = "_jt-0";
export var closeButtonContainer = "_jt-3";
export var iconContainer = "_jt-1";